import React from "react";
import { Col, Form, Row } from "react-bootstrap";

/**
 * Reusable labeled form field wrapper.
 * Renders a Form.Group with a right-aligned label column and a content column.
 * Label column widths default to the standard used across this app (sm=6, md=6, lg=4).
 *
 * Usage:
 *   <FormField controlId="sale_date" label="Sale Date">
 *     <DatePicker ... />
 *   </FormField>
 */
const FormField = ({
  controlId,
  label,
  labelSm = 6,
  labelMd = 6,
  labelLg = 4,
  children,
}) => (
  <Form.Group as={Row} controlId={controlId}>
    <Form.Label
      as={Col}
      className="text-right"
      column
      sm={labelSm}
      md={labelMd}
      lg={labelLg}
    >
      {label}
    </Form.Label>
    <Col>{children}</Col>
  </Form.Group>
);

export default FormField;
